// These methods allow you to:
//  - decorating the id with a decorator to get a globally unique id
//  - parsing the decorated id so that the original id can be read
// Example usage: ReportBaseSelectFilter - we need to generate a globally unique id from unique ids within given groups
//
// decorateIdentifier - creates a new id by concatenating the decorator with the original id
// e.g. decorateIdentifier(1, 'user') => "user__1"
export const decorateIdentifier = (id, decorator) => {
  return `${decorator}__${id}`;
};

// decorateIdentifier - creates a new id by concatenating the decorator with the original item id for a group of items
// e.g. decorateGroupWithUniqueIdentifier([{id: 1, name: 'User 1'}], 'user') => [{id: 'user__1', name: 'User 1'}]
export const decorateGroupWithUniqueIdentifier = (group, decorator) => {
  return group.map((item) => ({ ...item, id: decorateIdentifier(item.id, decorator) }));
};

// parseDecoratedIdentifier - decorated id parses to object with original id and decorator
// e.g. parseDecoratedIdentifier('user__1') => {decorator: 'user', id: '1'}
export const parseDecoratedIdentifier = (decoratedId) => {
  const ids = decoratedId.split('__');

  return {
    decorator: ids[0],
    id: ids[1],
  };
};
